import { BaseFrontdoorAdapter } from "../frontdoor/BaseFrontdoorAdapter";

/**
 * FrontdoorNotificationAdapter
 * Manages platform-level Notification operations via the Frontdoor REST API.
 * Endpoints sourced from: api_blueprint.md > Notifications
 */
export class FrontdoorNotificationAdapter extends BaseFrontdoorAdapter {
  /**
   * Get paginated notifications.
   * GET /api/notifications
   * @param {number} page
   * @param {number} perPage
   */
  async getAll({ page = 1, perPage = 25 } = {}) {
    return this.get("/api/notifications", { page, perPage });
  }

  /**
   * Get paginated notifications for a specific user.
   * GET /api/notifications/user/{userId}
   * @param {string} userId - Guid
   * @param {Object} pagination - { page, perPage }
   */
  async getByUser(userId, { page = 1, perPage = 25 } = {}) {
    return this.get(`/api/notifications/user/${userId}`, { page, perPage });
  }

  /**
   * Send a notification.
   * POST /api/notifications/send
   * @param {Object} payload - { title, data, userId }
   */
  async send(payload) {
    return this.post("/api/notifications/send", payload);
  }

  /**
   * Mark a specific notification as read.
   * PUT /api/notifications/{id}/read
   */
  async markAsRead(id) {
    return this.put(`/api/notifications/${id}/read`);
  }

  /**
   * Mark all notifications for the current user as read.
   * PUT /api/notifications/read-all
   */
  async markAllAsRead() {
    return this.put("/api/notifications/read-all");
  }
}
